import { render, staticRenderFns } from "./checkList.vue?vue&type=template&id=401a3ed4&scoped=true&"
import script from "./checkList.vue?vue&type=script&lang=js&"
export * from "./checkList.vue?vue&type=script&lang=js&"
import style0 from "./checkList.vue?vue&type=style&index=0&id=401a3ed4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401a3ed4",
  null
  
)

export default component.exports